import { Component, Input } from "@angular/core";
import { ContactPerson } from "src/app/meta/ContactPerson.interface";

@Component({
    selector: "ow-order-summary-contact-person",
    templateUrl: "./order-summary-contact-person.component.html"
})
export class OrderSummaryContactPersonComponent {

    @Input() contactPerson!: ContactPerson

}
